import { cn } from '@/utils/extra'

export default function InputTextField ({
  label,
  placeholder,
  value,
  setValue,
  ref,
  error
}) {
  return (
    <div>
      <label className={cn('block font-medium text-gray-200')}>
        {label}
        <input
          ref={ref}
          type='text'
          value={value}
          onChange={(e) => setValue(e.target.value)}
          className={cn(
            'mt-2 w-full rounded-lg border border-zinc-300 px-3 py-3 text-gray-800 placeholder-zinc-400 shadow-sm focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500',
            'lg:text-base sm:text-sm text-xs',
            error && 'border-red-500'
          )}
        />
        {error && <p className='text-red-500 lg:text-sm text-xs'>{error}</p>}
      </label>
    </div>
  )
}
